module.exports = __webpack_public_path__ + "img/rename--icon.6799a67b.png";